import * as React from 'react';
import { useLocation } from '@reach/router';
import styled from 'styled-components';

import { createUseCaseLink, navigate } from '../../utils';
import { Heading, Text } from '../design-system';

import {
  Author,
  GridItemWrapper,
  Info,
  PreviewImage,
  SubHeading
} from './sharedStyles';
import { type UseCaseItem } from './UseCaseGridItem';

const Wrapper = styled(GridItemWrapper)`
  flex-direction: row;
  margin-bottom: 20px;
  padding: 0;
`;

const StyledPreviewImage = styled(PreviewImage)`
  width: 500px;
  height: 300px;
`;

const StyledInfo = styled(Info)`
  padding: 40px;
`;

const StyledHeading = styled(Heading).attrs({ renderAs: 'h2' })`
  margin: 5px 0 10px 0;
`;

interface FeaturedUseCaseProps {
  useCase: UseCaseItem;
}

export const FeaturedUseCase: React.ComponentType<FeaturedUseCaseProps> =
  React.memo(({ useCase }) => {
    const { search } = useLocation();
    return (
      <Wrapper
        key={useCase.slug}
        onClick={() => {
          navigate(createUseCaseLink(useCase), search);
        }}>
        <StyledPreviewImage>
          {useCase.gridImage && (
            <img alt={useCase.gridImage.title} src={useCase.gridImage.url} />
          )}
        </StyledPreviewImage>
        <StyledInfo>
          <SubHeading>
            <span>Featured</span>
          </SubHeading>
          <StyledHeading renderAs="h2">{useCase.name}</StyledHeading>
          {useCase.author && <Author>{useCase.author}</Author>}
          <Text size="medium">{useCase.seoMetaDescription}</Text>
        </StyledInfo>
      </Wrapper>
    );
  });
